import React from 'react';
import { CheckOutlined } from '@ant-design/icons';

import { optionsNum } from '../../constant';
import { OptionItem } from '../../types';

import './index.less';

interface IProps {
  options: OptionItem[];
}

function SingleOption({ options }: IProps) {
  return (
    <ul className="manmade-multi-option">
      {
        options.map((item, index) => {
          return (
          <li key={item.id}>
            <div className="icon"><CheckOutlined /></div>
            <div>{optionsNum[index]}、</div>
            <div>{item.option}</div>
          </li>)
        })
      }
    </ul>
  )
}

export default SingleOption;
